import { Link } from "react-router-dom"

export const Aside = ({ isOpen, handleAsideClick }) => {
    return (
        <aside className={isOpen ? "bg-[black] max-w-xs p-8 flex flex-col items-center w-0" : "bg-[black] max-w-xs p-8 flex flex-col items-end w-full"}>
            <button className={isOpen ? "z-10 open sticky top-10 left-0" : "z-10 close sticky top-10 left-0"} onClick={handleAsideClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="12.828" viewBox="0 0 22.828 12.828">
                    <g transform="translate(-639.185 -729.386)">
                        <line x1="10" y2="10" transform="translate(650.6 730.8)" fill="none" stroke="#c7c7ba" strokeLinecap="round"
                            strokeWidth="2" />
                        <line x2="10" y2="10" transform="translate(640.6 730.8)" fill="none" stroke="#c7c7ba" strokeLinecap="round"
                            strokeWidth="2" />
                    </g>
                </svg>
            </button>
            <nav className={isOpen ? "hidden": "sticky top-10 left-0 w-full block"}>
                <ul>
                    <li className="text-2xl">
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="text-2xl">
                        <Link to="/dashboard/users">Users</Link>
                    </li>
                </ul>
            </nav>
        </aside >
    )
}